const phoneUS = "+1 (289) 294-0515";
const phonePK = "+92-51-5411278";
const emailPrimary = "contact@websailors.co";

export { phonePK, phoneUS, emailPrimary };
